'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURLTags = undefined;

var _actions = require('../utils/actions');

var getURLTags = exports.getURLTags = function getURLTags(url) {
  return {
    args: { url: url },
    type: 'CALL_MINDSELF_WS_SEND',
    types: (0, _actions.getFetchActionTypes)('getURLTags'),
    minselfAPIWSSend: function minselfAPIWSSend(client, id) {
      return client.send(JSON.stringify({ contentId: id, url: url }));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/ws.js
// module id = 511
// module chunks = 1